import type { FaqItem } from '../types/content'

export const faqs: FaqItem[] = [
  {
    question: '¿Sirve si no sé cocinar o soy principiante?',
    answer:
      'Sí, 100%. El Tomo 1 arranca desde cero. No necesitás saber cocinar — necesitás seguir el método. Si podés hervir agua y usar una sartén, podés hacer todo lo del pack.',
  },
  {
    question: '¿Cómo recibo el material después de pagar?',
    answer:
      'Inmediatamente después de confirmar el pago recibís un email con el enlace de descarga de todos los PDFs. Acceso en menos de 5 minutos desde cualquier dispositivo.',
  },
  {
    question: '¿Los ingredientes son fáciles de conseguir en Argentina?',
    answer:
      'Absolutamente. Todo el sistema está diseñado con ingredientes de supermercado, verdulería de barrio y feria. Sin ingredientes raros ni importados.',
  },
  {
    question: '¿Qué lo diferencia de buscar recetas en YouTube o Instagram?',
    answer:
      'Las recetas de YouTube te dan una receta. Este sistema te da el método completo: receta + lista de compras + tiempo exacto + planner semanal + checklist + sistema de viandas proteicas.',
  },
  {
    question: '¿La garantía de 7 días es real?',
    answer:
      '100% real. Escribís a closethegap14@gmail.com dentro de los 7 días y te devolvemos el dinero sin preguntas. Nuestra tasa de devolución es menor al 1% porque el sistema funciona cuando se usa.',
  },
]
